import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfnEcmUserService } from '@smex-app-cfn/smex-module-cfn-ecm-frontend';
import { EMPTY, Observable, catchError, finalize, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthorizationFrontendService } from '@numen/smex-lib-common-frontend';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredDialogComponent } from '../../shared/dialogs/session-expired-dialog/session-expired-dialog.component';

@Injectable()
export class InProgressInterceptor implements HttpInterceptor {

    private redirecting = false;

    constructor(private router: Router,
                private userService: CfnEcmUserService,
                private authorizationService: AuthorizationFrontendService,
                private dialog: MatDialog) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.userService.actionInProgress = true;
        return next.handle(req).pipe(
            catchError((error) => {
                if (error.status == 401 && !req.url.includes('/authorizations/')) {
                    if (!this.redirecting) {
                        this.redirecting = true;
                        const ref = this.dialog.open(SessionExpiredDialogComponent, { disableClose: true });
                        ref.afterClosed().subscribe(() => {
                            this.authorizationService.redirectToLogin(this.router.url);
                        });
                    }
                    return EMPTY;
                }
                return throwError(() => error);
            }),
            finalize(() => this.userService.actionInProgress = false));
        // return next.handle(req).pipe(finalize(() => setTimeout(() => this.userService.actionInProgress = false, 2000)));
    }

}
